import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex h-[43px] gap-4" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "mb-8 mt-8 border" }
const _hoisted_5 = { class: "mb-8 border" }
const _hoisted_6 = { class: "mb-8 border" }
const _hoisted_7 = {
  key: 0,
  class: "absolute inset-0 z-[100000] flex justify-center bg-[rgba(255,255,255,0.5)]"
}
const _hoisted_8 = { class: "mt-56" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_dx_date_box = _resolveComponent("dx-date-box")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createBlock(_component_main_section, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_table_action_header, {
              title: _ctx.$t('Sidebar.Statistics')
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_select, {
                class: "w-56",
                modelValue: _ctx.selectedFilterOption,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFilterOption) = $event)),
                options: _ctx.filterOptions,
                reduce: (option) => option.key,
                label: "label",
                clearable: false,
                searchable: false
              }, null, 8, ["modelValue", "options", "reduce"]),
              _createVNode(_component_dx_date_box, {
                modelValue: _ctx.from,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.from) = $event)),
                height: 43,
                "show-clear-button": true,
                "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                type: "datetime",
                max: _ctx.to
              }, null, 8, ["modelValue", "display-format", "max"]),
              _createVNode(_component_dx_date_box, {
                modelValue: _ctx.to,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.to) = $event)),
                height: 43,
                "show-clear-button": true,
                "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                type: "datetime",
                min: _ctx.from,
                max: _ctx.maxTo
              }, null, 8, ["modelValue", "display-format", "min", "max"]),
              _createVNode(_component_the_button, {
                icon: ['fas', 'rotate-left'],
                "button-type": "primaryButton",
                onExecuteMethod: _ctx.buttonPress
              }, null, 8, ["onExecuteMethod"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createBlock(_component_apexchart, {
                  key: _ctx.chartSeriesSessionLength.length,
                  type: "bar",
                  options: _ctx.chartOptionsSessionLength,
                  series: _ctx.chartSeriesSessionLength,
                  height: "500"
                }, null, 8, ["options", "series"]))
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_apexchart, {
                  key: _ctx.chartSeriesBar.length,
                  type: "bar",
                  options: _ctx.chartOptionsBar,
                  series: _ctx.chartSeriesBar,
                  height: "500"
                }, null, 8, ["options", "series"]))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(_component_apexchart, {
                  key: _ctx.chartSeriesLoad.length,
                  type: "bar",
                  options: _ctx.chartOptionsLoad,
                  series: _ctx.chartSeriesLoad,
                  height: "500"
                }, null, 8, ["options", "series"]))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              (_ctx.isLoadingGraphs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_small_loader, {
                        height: "h-16",
                        width: "w-16"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}